import React from 'react';
import { styled } from '@mui/system';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function FSW_Mobile_view_faq_comp() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className='pb-4'>
    <div className={classes.root}>
      <Accordion className='py-2' expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header" className='FAQ_background_color'
        >
          <Typography className='fs-6'>What do Full Stack Web Developers do?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A full Stack net Developer is someone who is acquainted with developing each consumer and server software. Further to learning CSS and HTML, they’re additionally know how to program browsers, databases, and servers.
          <br></br>To fully comprehend the function of complete Stack developer, you need to recognize the net development additives – front quit and back quit
          <br></br>ont end accommodates a visible a part of the software in which the user interacts, even as the returned stop includes enterprise logic.
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>What skills do you need to be a full-stack developer?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          A full Stack developer must be acquainted with: 
          <br></br>  
          <ul>
            <li>Simple languages – have to be talented in fundamental languages like HTML, CSS, and sq..</li>
            <li>Front-cease frameworks – BootStrap, AngularJS, VueJS, ReactJS, JavaScript, TypeScript, Python, Ruby, Hypertext Preprocessor</li>
            <li>Back-give up frameworks – express, Django, NodeJS, Ruby on Rails</li>
            <li>Databases – MySQL, SQLite, Postgres, MongoDB, Cassandra, Apache storm, Sphinx</li>
            <li>Additional talents advocated – Git, gadget studying, SSH, Linux Command, statistics systems, person encoding.</li>
          </ul>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion className='py-2' expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className='FAQ_background_color'
        >
          <Typography className='fs-6'>Explain Pair Programming?</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
          As the name suggests, Pair Programming is where two programmers share a single workstation. Formally, one programmer at the keyboard called the “driver” writes the code. The other programmer is the “navigator” views each line of the code written, spell check, and proofread it. Also, programmers will swap their roles every few minutes and vice-versa.
          </Typography>
        </AccordionDetails>
      </Accordion>

    </div>
    </div>
  );
}
